<template>
    <button id="HotspotLabelsButton" v-if="!onHomePage" @click="toggleHotspotLabels" :class="{'HotspotLabelsButton--show': isHotspotLabelsVisible}" aria-hidden="true">
        <!-- <img src="@/assets/img/ui/icn-eye.png" v-if="isHotspotLabelsVisible">
        <img src="@/assets/img/ui/icn-eye-closed.png" v-else> -->
        <IconEyeOpen v-if="isHotspotLabelsVisible"></IconEyeOpen>
        <IconEyeClosed v-else></IconEyeClosed>
    </button>
</template>
<script>
export default {
    props: ["onHomePage"],
    methods: {
        toggleHotspotLabels() {
            this.$store.commit('toggleShowHotspotLabels')
        }
    },
    computed: {
        isHotspotLabelsVisible() {
            return this.$store.getters.isHotspotLabelsVisible;
        }
    }
}
</script>
<style lang="scss">
    #HotspotLabelsButton {
        bottom:75px;
        left: 210px;
    
        &:hover {
            // background-image: url(@/assets/img/ui/hide-hotspot-labels-hover.png);
        }

     
    }
</style>